export default __webpack_public_path__ + "static/media/gallery_03.c79b1739.jpg";